import React from 'react';

import Pocket from '../../../components/DataTable/PocketDataTable';

export default function BreakingNews({ project }) {
    return (
        <Pocket
            type="breaking"
            project={project}
            columnsArray={[
                {
                    type: 'checkbox',
                    title: 'Активно',
                    accessor: 'is_active',
                    attributes: {
                        'data-type': 'active-multi',
                    },
                },
                {
                    type: 'title',
                    accessor: 'entity.title',
                },
                { type: 'edit' },
                { type: 'delete' },
            ]}
            requiredFields={[]}
            formFields={[
                {
                    type: 'storySearch',
                    name: 'storySearch',
                },
            ]}
        />
    );
}
